import { AnswerModel } from "./answer-model"
import { AppCertWizard } from "./app-cert-wizard.model"
import { Artifact } from "./artifact.model"
import { QuestionModel } from "./question.model"

export class ICertificationWizard extends AppCertWizard{
    sessionId!: string
    startDate: Date | null = null
    userId: string | null = null
    appId: string | null = null
    applicantId: string | null = null
    approach: string | null = null
    siteIdSecondary: string | null = null
    isComplete: boolean = false
    questions: QuestionModel[] = [];
    requiredArtifacts: Artifact[] = [];
    selectedAnswers: AnswerModel[] = [];
    disqualifiedApproaches: string | null = null;
    initiatorRole: {RoleName:string} = {RoleName:''};
}

export class CertificationWizard extends ICertificationWizard{

    constructor(options?: ICertificationWizard){
        super();
            if(options){
            this.sessionId = options.sessionId
            this.startDate = options.startDate ? new Date(options.startDate) : null;
            this.userId = options.userId;
            this.appId = options.appId;
            this.applicantId = options.applicantId;
            this.approach = options.approach,
            this.siteIdSecondary = options.siteIdSecondary
            this.isComplete = options.isComplete
            this.initiatorRole = options.initiatorRole
            this.disqualifiedApproaches = options.disqualifiedApproaches
            if(options.questions){
                options.questions.forEach(value =>{
                    this.questions?.push(new QuestionModel(value))
                })
            }
            if(options.requiredArtifacts){
                options.requiredArtifacts.forEach(value =>{
                    this.requiredArtifacts?.push(new Artifact(value))
                })
            }
            if(options.selectedAnswers){
                options.selectedAnswers.forEach(value =>{
                    this.selectedAnswers?.push(new AnswerModel(value))
                })
            }
            this.setAgentResponsibilityText(this.requiredArtifacts);
        }
    }

    toJSON(){
        return {
            sessionId: this.sessionId,
            startDate: this.startDate,
            userId: this.userId,
            appId: this.appId,
            applicantId: this.applicantId,
            approach: this.approach,
            siteIdSecondary: this.siteIdSecondary,
            isComplete: this.isComplete,
            initiatorRole: this.initiatorRole,
            disqualifiedApproaches: this.disqualifiedApproaches,
            questions: this.questions.map(i=>i.toJSON()),
            requiredArtifacts: this.requiredArtifacts.map(i=>i.toJSON()),
            selectedAnswers: this.selectedAnswers.map(i=>i.toJSON())
        }
    }
}